module.exports = __webpack_public_path__ + "static/media/illu-header-clea@2x.9795ed5d.png";